import { Entry } from '../Entry'

export function Entry20260122() {
  return (
    <Entry title="2026 Jan 22 - v3.11.6">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/21521/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
